import { CRUDAction, FeatureKey } from 'common/constants/permission'
import useMedia from 'common/hooks/useMedia'
import { usePermitToActionFeature } from 'modules/user/api/selector'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { RecordFeatureButton } from 'components/RecordFeatureButton'

import ShrimpSalesRecord from '../ShrimpSalesRecord'
import ShrimpSalesRecordDialog from '../ShrimpSalesRecordDialog'
import ShrimpSalesSummary from '../ShrimpSalesSummary'

const ShrimpSales = () => {
  const { t } = useTranslation(['shrimpSales'])
  const isMobile = useMedia('sm')
  const showRecordBtn = usePermitToActionFeature([CRUDAction.Create], FeatureKey.Sales)
  return (
    <Box sx={{ py: isMobile ? 0 : 3 }}>
      <RecordFeatureButton
        buttonText={t('record.harvest')}
        dialog={({ open, onClose }) => <ShrimpSalesRecordDialog open={open} onClose={onClose} />}
        showButton={showRecordBtn}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ShrimpSalesRecord />
        </Grid>
        <Grid item xs={12}>
          <ShrimpSalesSummary />
        </Grid>
      </Grid>
    </Box>
  )
}

export default ShrimpSales
